import React from 'react';
import { PropTypes } from 'prop-types';
import ThemeWrapper from '../../wrapper/ThemeWrapper';
import ErrorScreen from '../ErrorScreen';

const ErrorBounderyFallback = (props) => {
  const { error } = props;
  const { message } = error;

  return (
    <ThemeWrapper>
      <ErrorScreen errorMessage={message} />
    </ThemeWrapper>
  );
};

ErrorBounderyFallback.propTypes = {
  error: PropTypes.object.isRequired,
  resetErrorBoundary: PropTypes.func,
};

export default ErrorBounderyFallback;
